import React from "react";
import styled from "styled-components";
import { Colors } from "../../ColorConstants";
import { Text } from "../../TextConstants";
import PurchasedProducts from "./PurchaseProducts";

const PurchaseDetails = ({
  data,
  onCancelTicket,
  isCancelTicket,
  setCancelTicket,
  onOpenCancelModal,
}) => {
  return (
    <PurchaseDetailMainContainer>
      <PurchaseHeaderContainer>
        <PurchaseHeader>
          <PurchaseTitles style={{ width: "11%" }}></PurchaseTitles>
          <PurchaseTitles style={{ width: "18%" }}>
            {Text.ticketId_reservation}
          </PurchaseTitles>
          <PurchaseTitles style={{ width: "22%" }}>
            {Text.visitDate_time}
            {"/Reservation Date"}
          </PurchaseTitles>
          <PurchaseTitles style={{ width: "18%" }}>
            {Text.products}
          </PurchaseTitles>
          <PurchaseTitles style={{ width: "15%" }}>
            {Text.qtyDuration}
          </PurchaseTitles>
          <PurchaseTitles style={{ marginRight: "1rem" }}>
            {Text.status}
          </PurchaseTitles>
          <PurchaseTitles>{Text.action}</PurchaseTitles>
          <PurchaseTitles>{Text.ticket}</PurchaseTitles>
        </PurchaseHeader>
      </PurchaseHeaderContainer>
      {data.length > 0 ? (
        <ProductDetailContainer>
          <ProductDetail>
            {data?.map((item, index) => (
              <PurchasedProducts
                item={item}
                key={index}
                onCancelTicket={onCancelTicket}
                isCancelTicket={isCancelTicket}
                setCancelTicket={setCancelTicket}
                onOpenCancelModal={onOpenCancelModal}
              />
            ))}
          </ProductDetail>
        </ProductDetailContainer>
      ) : (
        <NoDataContainer>
          <span>No Records Found</span>
        </NoDataContainer>
      )}
    </PurchaseDetailMainContainer>
  );
};
export const PurchaseDetailsMobile = ({ data, isModal, onOpenCancelModal }) => {
  const getReservationDate = (date) => {
    const inputDate = new Date(date);
    const options = { year: "numeric", month: "short", day: "numeric" };
    const formattedDate = inputDate.toLocaleDateString(undefined, options);
    return formattedDate;
  };
  const title = (name) => {
    console.log("name", name);
    const updatedTitle = name.charAt(0).toUpperCase() + name.slice(1);
    return updatedTitle;
  };

  return (
    <PurchaseDetailMobileContainer isModal={isModal}>
      {data?.length > 0 ? (
        data?.map((item) => (
          <PurchaseMobileContainer key={item._id}>
            <Title>
              {item?.typeOfBooking === "reservation"
                ? title(item?.venue)
                : item?.shortName === "aqua_zone"
                ? "Aqua Zone"
                : item?.shortName === "winter"
                ? "LWW"
                : title(item?.shortName)}
            </Title>
            <ProductImage src={item.img} />
            <SubTitle>
              {item?.typeOfBooking === "reservation"
                ? "Reservation No"
                : Text.ticketId}
            </SubTitle>
            <Values>
              {item?.typeOfBooking === "reservation"
                ? item?.reference_code
                : item?.ticketNo}
            </Values>
            <VisitAndStatusContainer>
              <VisitContainer>
                <SubTitle style={{ marginTop: "0" }}>
                  {item?.typeOfBooking === "reservation"
                    ? Text.reservation_date
                    : Text.visitDate_time2}
                </SubTitle>
                <Values>
                  {item?.typeOfBooking === "reservation"
                    ? getReservationDate(item?.date)
                    : item?.visitTime}
                </Values>
              </VisitContainer>
              {item?.typeOfBooking !== "reservation" && (
                <ProductButtonStatus bgcolor={Colors.orange}>
                  {item?.tag?.toLocaleUpperCase()}
                </ProductButtonStatus>
              )}
            </VisitAndStatusContainer>
            <PurchaseList>
              <ProductMultiValues>
                {item?.typeOfBooking === "reservation" ? (
                  <ProductName>{item?.venue}</ProductName>
                ) : (
                  item?.items?.map((item, index) => (
                    <ProductDetailContainer2 key={index}>
                      <ProductName>{item?.name}</ProductName>
                      <DurationContainer>
                        <SubTitle style={{ marginTop: "0" }}>
                          {Text.qtyDuration}
                        </SubTitle>
                        {item?.slots?.length > 0 ? (
                          item?.slots?.map((value, index) => (
                            <Values key={index}>
                              {value?.aquaDuration}
                              {" Min"}
                            </Values>
                          ))
                        ) : (
                          <Values key={index}>
                            {item?.qty}
                            {" Unit"}
                          </Values>
                        )}
                      </DurationContainer>
                    </ProductDetailContainer2>
                  ))
                )}
              </ProductMultiValues>
            </PurchaseList>
            {item?.isCancellationEnabled && !isModal && (
              <ProductAnchorValues
                color={Colors.red}
                onClick={() => onOpenCancelModal(item?._id)}
              >
                Cancel ticket
              </ProductAnchorValues>
            )}
          </PurchaseMobileContainer>
        ))
      ) : (
        <NoDataContainer>
          <span>No Records Found</span>
        </NoDataContainer>
      )}
    </PurchaseDetailMobileContainer>
  );
};

const PurchaseDetailMainContainer = styled.div`
  flex-direction: column;
  display: flex;
  justify-content: center;
  margin-top: 2.5rem;
  width: 64rem;
  @media only screen and (max-width: 1024px) {
    width: 100%;
  }
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;
const PurchaseHeaderContainer = styled.div`
  display: flex;
  background-color: ${Colors.lightishGrey};
  justify-content: center;
  border: 1px solid ${Colors.lightShadeBlue};
  border-radius: 0.5rem;
`;
const ProductDetailContainer = styled.div`
  display: flex;
  justify-content: center;
`;
const PurchaseHeader = styled.div`
  width: 100%;
  display: flex;
  padding: 0.5rem 0;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 1.5rem;
`;
const ProductDetail = styled.div`
  width: 100%;
  padding: 0.5rem 0;
  background-color: ${Colors.white};
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  gap: 0rem;
  @media only screen and (max-width: 1024px) {
    gap: 0rem;
  }
`;

const PurchaseTitles = styled.span`
  color: ${Colors.mediumBlue};
  text-align: center;
  font-size: 0.8rem;
  font-weight: 500;
  width: 13%;
  text-align: left;
`;
const NoDataContainer = styled.div`
  display: flex;
  justify-content: center;
  font-size: 1.5rem;
  margin-top: 2rem;
  color: ${Colors.darkishBlue};
`;

// for mobile
const PurchaseDetailMobileContainer = styled.div`
  @media only screen and (min-width: 768px) {
    display: ${(props) => (props.isModal ? "flex" : "none")};
    width: 100%;
    margin-top: 1.5rem;
  }
  @media only screen and (max-width: 768px) {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    margin-top: 2rem;
    box-sizing: border-box;
    padding: 0 1rem;
    gap: 1rem;
    justify-content: center;
  }
`;
const PurchaseMobileContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  border: 1px solid ${Colors.lightShadeBlue};
  background: ${Colors.bgGrey};
  padding: 1.2rem;
  position: relative;
  width: ${(props) => (props.isModal ? null : "100%")};
  @media only screen and (max-width: 768px) {
    width: 40%;
  }
  @media only screen and (max-width: 430px) {
    width: 80%;
  }
`;
const Title = styled.span`
  color: ${Colors.aqua};
  font-size: 14px;
  font-weight: 500;
`;
const SubTitle = styled.span`
  color: ${Colors.black};
  font-size: 14px;
  font-weight: 500;
  margin-top: 0.8rem;
`;
const Values = styled.span`
  color: ${Colors.black};
  font-size: 12px;
  font-weight: 400;
`;
const VisitAndStatusContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 0.8rem;
  justify-content: space-between;
`;
const VisitContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
const ProductButtonStatus = styled.button`
  color: ${Colors.white};
  border: none;
  background-color: ${(props) => props.bgcolor};
  font-size: 0.8rem;
  font-weight: 400;
  border-radius: 6px;
  display: flex;
  align-items: center;
  height: 1.5rem;
  padding: 0 1rem;
`;
const PurchaseList = styled.div`
  display: flex;
  margin-top: 1rem;
  width: 100%;
`;
const ProductName = styled.span`
  color: ${Colors.black};
  font-size: 14px;
  font-weight: 400;
  width: ${(props) => (props.isModal ? null : "60%")};
`;
const DurationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;
const ProductAnchorValues = styled.span`
  color: ${(props) => props.color};
  font-size: 0.75rem;
  font-weight: 400;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  text-decoration: underline;
  margin-top: 1rem;
`;
const ProductImage = styled.img`
  width: 3rem;
  height: 2.5rem;
  display: flex;
  position: absolute;
  top: 2rem;
  right: 2rem;
`;
const ProductMultiValues = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
`;
const ProductDetailContainer2 = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const TextInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  margin-top: 0.5rem;
`;
const MainText = styled.span`
  color: ${Colors.darkishBlue};
  text-align: center;
  font-size: 1rem;
  font-weight: 700;
`;
const SubText = styled(MainText)`
  color: #e8aa28;
  text-align: center;
  font-size: 0.6rem;
  font-weight: 400;
  width: 90%;
  margin-top: 0.5rem;
`;
const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
  align-self: flex-start;
  padding-left: 1.2rem;
  width: 90%;
`;
const InputTitle = styled.span`
  color: ${Colors.darkishBlue};
  font-size: 0.9rem;
  font-weight: 500;

  span {
    color: ${Colors.red};
  }
`;
const TextInput = styled.textarea`
  margin-top: 0.5rem;
  border-radius: 8px;
  padding: 0.5rem;
`;
const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 1rem;
  width: 90%;
  justify-content: space-between;
`;
export default PurchaseDetails;
